<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">IBOSS Permission</div>
                <div class="content">
                    <table>
                        <thead>
                            <tr id="top">
                                <th scope="col" style="width: 70px">No</th>
                                <th scope="col">Permission Date</th>
                                <th scope="col">Permission No</th>
                                <th scope="col">Company Name</th>
                                <th scope="col">Register No</th>
                                <th scope="col">Application Letter No</th>
                                <!-- <th scope="col" rowspan="2">Status</th> -->
                                <th scope="col">Description</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, i) in dataTransaction" :key="i" v-show="dataTransaction != 0">
                                <td data-label="No">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                                <td data-label="Deposite Date">{{ data.tgl_daftar | formatDate }}</td>
                                <td data-label="Dimension">{{ data.no_ijin }}</td>
                                <td data-label="Weight">{{ data.nama_persh }}</td>
                                <td data-label="Fineness">{{ data.no_pendaftaran }}</td>
                                <td data-label="Hallmark">{{ data.no_surat_mohon }}</td>
                                <td data-label="Serial Number">{{ data.urailayan }}</td>
                                <td data-label="Action">
                                    <router-link :to="'/permission-detail/' + data.id_ijin">
                                        <b-button variant="outline-info" size="sm" class="m-1">Detail</b-button>
                                    </router-link>
                                </td>
                            </tr>
                            <tr v-show="dataTransaction.length == 0">
                                <td colspan="10">No Data Available in Table</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="self-modal" v-show="selected">
                        <div class="content-modal">
                            <div class="title-header">
                                <span>Approval Storage Operator</span>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selected = false">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="body-modal">
                                <div class="content-title">Are you sure to approve this storage operator?</div>
                            </div>
                            <div class="footer-modal">
                                <div class="button btn-scondary" @click="selected = false">
                                    <div>Cancel</div>
                                </div>
                                <div class="button btn-primer" @click="approveDeposite">
                                    <div v-show="isLoadingOtp == false">Approve</div>
                                    <Loading v-show="isLoadingOtp" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="lengthData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="lengthData > 10"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "../components/utility/Loader.vue";
export default {
    components: {
        Loading,
    },
    data() {
        return {
            dataTransaction: [],
            dataContract: [],
            isLoading: false,
            isLoadingOtp: false,
            selected: "",
            pageOfItems: [],
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            trade_id: [],
            offset: 0,
            data_id: "",
            data: [],
            listVendor: [],
            role: "",
            today: "",
            form: {
                info: "",
                owner: "",
                contract_id: "",
                allocated: "",
                hub: "Jakarta",
                deposite_date: "",
                dimension: "",
                fineness: "",
                hallmark: "",
                weight: "",
                serial_number: "",
                year: "",
                item_description: "",
            },
            client: null,
            lenghtDim: "",
            widthDim: "",
            hightDim: "",
            abxDeposite: Boolean,
            typeDeposit: "onexchange",
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        this.getData();
        this.role = sessionStorage.getItem("role");
    },
    methods: {
        handlePageChange(value) {
            this.getData(value, this.typeDeposit);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        getData() {
            axios.get("/v2/clearing/admin/abx/get/list_ijin?offset=&limit=10").then((res) => {
                this.dataTransaction = res.data.data.body;
                this.lengthData = res.data.data.count;
            });
        },

        approveDeposite() {
            let url;
            if (this.role == 2 || this.role == 3) {
                url = "/v1/clearing/admin/abx/deposit/confirmation";
            } else {
                url = "/v1/clearing/admin/deposit/confirmation";
            }
            this.isLoadingOtp = true;
            axios
                .put(url, { _id: this.data_id })
                .then((res) => {
                    if (res.status == 200) {
                        this.isLoadingOtp = false;
                        this.$toast.success(res.data.message);
                        setTimeout(function () {
                            location.reload();
                        }, 3000);
                    }
                })
                .catch((error) => {
                    this.isLoadingOtp = false;
                    this.$toast.error(error.response.data.message);
                });
        },
    },
    computed: {
        rows() {
            return (this.currentPage - 1) * this.perPage;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.nav-tab {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #636366;
    padding: 0.8rem 0;
}

.tab {
    padding: 0.8rem 1rem;
    cursor: pointer;
}

.tab:hover,
.activeTab {
    color: var(--clr-scondary);
    border-bottom: 2px solid var(--clr-scondary);
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

label {
    width: 50%;
}

.label-client {
    width: 25%;
}

.form-input,
input {
    width: 100%;
}

.form-group {
    display: flex;
}

.form-input,
input {
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 0 10px;
    font-size: 13px;
}

.dimension {
    width: 5.5rem;
    margin-right: 1.5rem;
}

.dimension:last-child {
    margin-right: unset;
}

.buuton-add {
    text-align: right;
    font-size: 13px;
}

.content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.icon-trade {
    width: 25px;
}

.footer {
    background: var(--clr-primary);
    color: white;
    padding: 20px 47px;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 62px;
}

.filter {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-size: 12px;
    flex-wrap: wrap;
}

.wrap-input {
    margin-bottom: 10px;
}
.label-input {
    width: 108px;
}
select {
    width: 130px;
    border-radius: 3px;
    border-color: #a5a5a5a5;
    padding: 3px;
}

.card {
    width: 314px;
    font-size: 14px;
    border-radius: 10px;
}

.card-header {
    padding: 1rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    position: relative;
    left: 20px;
}

.title::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--clr-scondary);
    left: -17px;
    top: 3px;
}

.buyer {
    margin-bottom: 20px;
}

.content-right {
    text-align: right;
}

.amount {
    font-weight: bold;
}

.body-modal {
    text-align: center;
    padding: 10px;
}

.content-title {
    font-size: 20px;
    font-weight: bold;
    margin-top: 20px;
}
.btn-primer {
    background: var(--clr-scondary);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-scondary {
    border: solid 1px var(--clr-scondary);
    color: var(--clr-scondary);
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-primer:hover,
.btn-scondary:hover {
    background-color: var(--clr-scondary-hover);
    color: #ffffff;
}

.clearing {
    /* background: rgba(50, 90, 115, 0.1); */
    font-weight: 600;
    color: rgb(50, 90, 115);
    border-radius: 5px;
}
.operator {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(252, 108, 4);
    border-radius: 5px;
}
.abx {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(172, 143, 26);
    border-radius: 5px;
}
.stored {
    /* background: rgba(40, 167, 69, 0.1); */
    font-weight: 600;
    color: rgb(40, 167, 69);
    border-radius: 5px;
}

.vendor {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(250, 194, 75);
    border-radius: 5px;
}

.reject {
    font-weight: 600;
    color: rgb(250, 119, 75);
    border-radius: 5px;
}
</style>
